// extracted by mini-css-extract-plugin
module.exports = {"moreButton":"MoreButton_moreButton__p_uOS","icon":"MoreButton_icon__CVjSD","brand":"MoreButton_brand__npPP_","secondary":"MoreButton_secondary__lCwC2"};